// extracted by mini-css-extract-plugin
module.exports = {"consent":"Consent--consent--3S4MD","consent__text":"Consent--consent__text--2BJx_","consent__button":"Consent--consent__button--2Ggo_"};